var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnouncementMobile = function SvgAnnouncementMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 90,
    fill: "none",
    viewBox: "0 0 137 123"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#announcementMobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCE5F4",
    d: "M36.59 86.044c3.754 8.082 8.658 16.417 15.068 24.193a7.7 7.7 0 0 1-1.05 10.846 7.7 7.7 0 0 1-2.311 1.312 7.72 7.72 0 0 1-8.547-2.361c-6.98-8.466-12.95-18.147-17.763-28.784l14.6-5.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDBF0",
    d: "M26.999 95.418a61 61 0 0 1-2.308-5.132l-2.704.964c4.816 10.637 10.784 20.318 17.763 28.784a7.72 7.72 0 0 0 8.547 2.361 7.7 7.7 0 0 0 2.31-1.312 7.7 7.7 0 0 0 2.341-3.305c-7.52.836-18.82-8.263-25.949-22.36M45.057 100.995a1.205 1.205 0 0 0 .583-1.827 32.8 32.8 0 0 1-4.055-7.835l-5.551 1.979a33 33 0 0 0 3.915 7.635 2.39 2.39 0 0 0 2.77.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.795 100.545a2.39 2.39 0 0 1-2.769-.881 33 33 0 0 1-3.618-6.843l-1.376.491a33 33 0 0 0 3.916 7.635 2.39 2.39 0 0 0 2.769.881l2.338-.833c.522-.186.82-.681.8-1.185l-2.062.735z",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF415C",
    d: "m18.747 66.91-15.07 5.373c-2.57.916-3.84 3.945-2.832 6.762L5 90.683c1.007 2.819 3.907 4.36 6.477 3.443l17.186-6.127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF496F",
    d: "m.845 79.047.21.589 13.862-4.942 2.23-7.211-13.47 4.802c-2.57.916-3.84 3.945-2.832 6.762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC335C",
    d: "m11.478 94.128 13.277-4.732-6.027-4.216-13.922 4.964.195.543c1.006 2.82 3.906 4.36 6.476 3.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF295C",
    d: "M38.642 49.475 10.91 59.361c-4.73 1.687-7.064 7.258-5.212 12.444l7.647 21.415c1.852 5.187 7.19 8.023 11.92 6.337l31.622-11.274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C6E",
    d: "m5.7 71.805.386 1.084 25.508-9.094 4.103-13.27-24.785 8.836C6.182 61.048 3.848 66.62 5.7 71.805"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD295C",
    d: "m25.266 99.557 24.431-8.71-11.089-7.757-25.617 9.133.356.998c1.852 5.186 7.189 8.022 11.919 6.336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE5F4",
    d: "M30.546 52.364s-1.312 20.362 14.33 40.171c34.807-8.941 64.68-4.095 76.538-1.407 2.415.548 4.26-1.937 3.343-4.499L96.12 6.437c-.915-2.562-3.916-3.319-5.44-1.368-7.475 9.572-27.528 32.203-60.136 47.295z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF6FF",
    d: "m31.595 63.795 73.332-32.7L96.12 6.437c-.915-2.562-3.915-3.319-5.44-1.368-7.475 9.572-27.528 32.203-60.136 47.295 0 0-.292 4.547 1.049 11.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDBF0",
    d: "M38.609 83.09a68.7 68.7 0 0 0 6.267 9.445c34.807-8.941 64.68-4.095 76.538-1.407 2.415.548 4.26-1.937 3.343-4.5l-7.785-21.8-78.363 18.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF295C",
    d: "M96.786 1.397c-11.074 3.947-12.958 27.007-4.208 51.506 8.748 24.499 24.818 41.158 35.89 37.208 11.074-3.947 10.497-26.13 1.749-50.629S107.86-2.553 96.787 1.397m30.699 83.51c-9.453 3.372-23.42-11.55-31.199-33.328C88.51 29.8 89.868 9.415 99.321 6.044c9.454-3.371 21.323 12.3 29.099 34.077 7.776 21.778 8.519 41.415-.935 44.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD295C",
    d: "M96.285 51.579c7.777 21.777 21.746 36.697 31.199 33.328 9.454-3.37 8.711-23.008.935-44.784-7.776-21.777-19.645-37.448-29.098-34.077-9.454 3.371-10.812 23.757-3.036 45.535z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD295C",
    d: "M92.578 52.9C84.04 28.999 85.629 6.47 95.995 1.72c-.297.08-.594.167-.889.272-12.13 4.325-14.87 27.691-6.123 52.187 8.748 24.5 25.674 40.853 37.805 36.528.295-.105.581-.225.863-.351-11.035 2.88-26.537-13.557-35.073-37.457zM130.217 39.482s-.009-.022-.011-.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE5F4",
    d: "M96.285 51.579c1.817 5.086 3.97 9.799 6.326 13.99l10.303-9.653-6.505-18.217-14.092-.955c.832 4.734 2.151 9.746 3.968 14.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDBF0",
    d: "M111.566 46.132c1.804 5.05 2.413 9.444 1.362 9.819s-3.363-3.415-5.166-8.461c-1.804-5.05-2.413-9.444-1.363-9.82 1.05-.374 3.363 3.416 5.167 8.462"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EDF6FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.475,
    d: "m97.83 41.537 4.159.304"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "announcementMobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.84h136.283v122H.5z"
  })))));
};
export default SvgAnnouncementMobile;